module.exports = __webpack_public_path__ + "img/tutorial_war_04.be1b7343.gif";